import styled from 'styled-components';

export const Card = styled.div`
    /* ${props => console.log(props)} */
    /* border: 1px solid #cecece; */

`;

export const Heading = styled.div`
    /* border: 1px dotted blue; */
`;

export const Title = styled.div`
    /* outline: 1px dashed brown; */
`;

export const Body = styled.div`
    /* outline: 1px solid green; */
`;
